var map = {
	"./calming-module.svg": 11081,
	"./exposure-module.svg": 1967,
	"./flexibility-module.svg": 73047,
	"./knowledge-module.svg": 34564,
	"./meditation-module.svg": 65094,
	"./mindset-module.svg": 40556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64713;